var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            "append-to-body": true,
            title: _vm.customTitle == "" ? _vm.title : _vm.customTitle,
            "close-on-click-modal": false,
            visible: _vm.visible,
            "before-close": _vm.close,
            width: "1260px",
            hei: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-descriptions",
                    {
                      attrs: {
                        title: "",
                        size: "large",
                        column: 2,
                        border: "",
                        contentStyle: _vm.CS,
                        "label-style": _vm.LS,
                      },
                    },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "上次操作人员" } },
                        [_vm._v(_vm._s(_vm.inputForm.actorName))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "操作时间" } },
                        [_vm._v(_vm._s(_vm.inputForm.startTime))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "事件分类" } },
                        [_vm._v(_vm._s(_vm.inputForm.category))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "事件名称" } },
                        [_vm._v(_vm._s(_vm.inputForm.categoryName))]
                      ),
                      _vm.ifDescription
                        ? _c(
                            "el-descriptions-item",
                            { attrs: { label: "说明", span: 2 } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: { minRows: 2, maxRows: 5 },
                                },
                                model: {
                                  value: _vm.inputForm.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.inputForm, "description", $$v)
                                  },
                                  expression: "inputForm.description",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "文件", span: 2 } },
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              {
                                staticClass: "tc",
                                staticStyle: { "min-width": "100px" },
                              },
                              [
                                _vm._v("文件"),
                                _c("br"),
                                _vm._v("(可拖动上传)"),
                                _c("br"),
                                _vm._v("(可粘贴上传截图)"),
                              ]
                            ),
                          ]),
                          _c("file-upload", {
                            ref: "fileUploadRef",
                            attrs: {
                              "max-height": 400,
                              "max-width": 360,
                              "root-path": _vm.inputForm.fileStorePath,
                              "folder-name": _vm.inputForm.ownerCode,
                              ifSetUploadName: _vm.ifSetUploadName,
                              updateParams: {
                                fileName: _vm.uploadInfo.fileName,
                                tip: _vm.uploadInfo.tip,
                                code: _vm.uploadInfo.type,
                              },
                              watermark: "",
                              owner: _vm.ownerImg,
                              "read-only": _vm.method == "view",
                              visible: _vm.visible,
                              limit: 1,
                            },
                            model: {
                              value: _vm.inputForm.filesIn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "filesIn", $$v)
                              },
                              expression: "inputForm.filesIn",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-close", type: "danger" },
                  on: { click: _vm.close },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { type: "success", icon: "el-icon-check" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }